import search from './search';
import question from './question';
import isElem from '../../scripts/util/isElement';
import select from '../support-category/select';
// import popup from '../support-category/popup';
import isMobile from 'ismobilejs';
import $ from 'jquery';

const selectors = {
	sidebar: '.js-accordeon',
	content: '.js-content-with-aside',
	listBlock: '.list__block',
	listItemHidden: '.list__item-hidden',
	listItemsShowMore: '.js-list-item-show-more',
	filter: '.js-faq-menu-fixed'
};

const classes = {
	fixed: 'mod--menu-fixed',
	fixedBottom: 'mod--menu-fixed-bottom',
	listItemHidden: 'list__item-hidden',
	listItemLinkHidden: 'list__item-link-hidden'
};

let tempScrollTop = 0;
let currentScrollTop = 0;

const fixedMenu = () => {
	const sidebarOffset = $(selectors.sidebar).offset().top;
	$(window).scroll(function () {
		if ($(window).scrollTop() > sidebarOffset) {
			if (!$(selectors.content).hasClass(classes.fixed)) {
				$(selectors.content).addClass(classes.fixed);
			}
			const sidebarHeight = $(selectors.filter).height();
			if (sidebarHeight >= $(window).height()) {
				const floatDelta = parseInt(sidebarHeight - $(window).height(), 10);
				currentScrollTop = $(window).scrollTop();
				if (tempScrollTop < currentScrollTop ) {
					$(selectors.filter).css('top', -floatDelta);
				}
				else if (tempScrollTop > currentScrollTop ) {
					$(selectors.filter).css('top', 20);
				}
				tempScrollTop = currentScrollTop;
			}
		} else {
			$(selectors.content).removeClass(classes.fixed);
		}
		if ($(window).scrollTop() + $(selectors.sidebar).outerHeight() > $(selectors.content).offset().top + $(selectors.content).outerHeight()) {
			$(selectors.content).removeClass(classes.fixed);
			$(selectors.content).addClass(classes.fixedBottom);
			$(selectors.filter).attr('style', '');
		}
		else {
			$(selectors.content).removeClass(classes.fixedBottom);
		}
	});
};

const render = () => {
	if (isElem('.support')) {
		search();
		question();
		if ($('.support-subcategory').length > 0 && !isMobile.phone) {
			fixedMenu();
		}
	}
	if (isElem('.support-category')) {
		select();
		// popup();

		$(selectors.listItemsShowMore).on('click', function (e) {
			e.preventDefault();
			$(this).closest(selectors.listBlock).find(selectors.listItemHidden).removeClass(classes.listItemHidden);
			$(this).addClass(classes.listItemLinkHidden);
		});
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/support/support.js